import { defineComponent, computed } from 'vue';
import SquareCheckMark from '../../../assets/icons/square-checkmark.svg.js';
import SquareErrorCheckmark from '../../../assets/icons/square-error-checkmark.svg.js';
import SquarePendingIcon from '../../../assets/icons/square-pending.svg.js';
import __vue_component__$2 from '../../cards/BasicCard/BasicCard.vue.js';
import { CardStyle } from '../../cards/BasicCard/model.js';
import __vue_component__$1 from '../../specific/SupplyLabel/SupplyLabel.vue.js';
import __vue_component__ from '../../ui/Icon.vue.js';

var script = defineComponent({
    name: 'ScanningSupplyRow',
    components: {
        SquareErrorCheckmark,
        Icon: __vue_component__,
        SupplyLabel: __vue_component__$1,
        SquareCheckMark,
        SquarePendingIcon,
    },
    props: {
        /** Render each row as an individual card */
        clickMode: Boolean,
        forceCardView: Boolean,
        isScanned: Boolean,
        isScanningDisabled: Boolean,
        label: {
            type: String,
            default: 'Unknown supply',
        },
        cardStyleOverride: {
            type: String,
            default: undefined,
        },
        customPendingIcon: {
            type: String,
            default: null,
        },
        isScanSuccess: {
            type: Boolean,
            default: true,
        },
        /** If passed, shows the serial number below the supply name */
        serial: {
            type: String,
            default: null,
        },
        shortSerial: Boolean,
        supply: {
            type: Object,
            default: null,
        },
    },
    emits: ['click'],
    setup(props, { emit }) {
        const tag = computed(() => props.clickMode || props.forceCardView ? __vue_component__$2 : 'div');
        const cardStyle = computed(() => {
            if (props.cardStyleOverride) {
                return props.cardStyleOverride;
            }
            if (props.clickMode) {
                return CardStyle.WHITE_WITH_BORDER;
            }
            if (props.forceCardView) {
                return CardStyle.GREY_WITH_BORDER;
            }
            return undefined;
        });
        const onClick = () => {
            if (props.isScanningDisabled || props.clickMode) {
                emit('click');
            }
        };
        const computedSupply = computed(() => { var _a; return (_a = props.supply) !== null && _a !== void 0 ? _a : { name: props.label }; });
        const classes = computed(() => {
            const classesArray = [];
            if (props.isScanningDisabled) {
                classesArray.push('is-clickable');
            }
            return classesArray;
        });
        return {
            cardStyle,
            classes,
            computedSupply,
            onClick,
            tag,
        };
    },
});

export { script as default };
